import { render, staticRenderFns } from "./ClientAT.vue?vue&type=template&id=1d83c9ca&scoped=true&"
import script from "./ClientAT.vue?vue&type=script&lang=js&"
export * from "./ClientAT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d83c9ca",
  null
  
)

export default component.exports